module.exports = __webpack_public_path__ + "assets/img/29_247_big.838e6594.jpg";